export enum ValueAggregation {
    raw = 'raw',
    commulative = 'commulative',
    average = 'average',
    max = 'max',
    min = 'min'
}

export enum TimeRange {
    day = 'day',
    week = 'week',
    month = 'month',
    year = 'year'
}

export interface BenchmarkDashboardDatapoint {
    datapointId : string;
    plantId: string;
    color?: string;
    name?: string
}

export interface BenchmarkDashboardChart {
    datapoints: BenchmarkDashboardDatapoint[]
}

export interface EngergyDashboardData {
    from: number
    to: number
    valueAggregation : ValueAggregation
    aggregationRange: TimeRange
    compareRange: TimeRange
    charts: BenchmarkDashboardChart[],
    chartWidth?: number
}